import moment from "moment";

export function getOrderActions(status) {
  const finalStates = [
    "Delivered",
    "delivered",
    "Cancelled",
    "cancelled",
    "Returned",
    "closed",
  ];

  const rtoStates = [
    "Shipped & Returned",
    "rto-delivered",
    "rto-initiated",
    "RTO lock",
    "RTO In Transit",
    "rto in transit",
  ];

  const cancellableStates = [
    "confirmed",
    "allocated",
    "Allocated",
    "Pick complete",
    "packed",
    "Packed",
    "picked",
    "order placed",
    "pick complete",
    "part allocated",
    "part picked",
  ];

  const activeStates = [
    "Intransit",
    "Out for Delivery",
    "LostInTransit",
    "Shipped complete",
    "OFD lock",
    "Packed",
    "Partially Shipped",
    "Part Allocated",
    "Allocated",
    "confirmed",
    "Pick complete",
    "Part Picked",
  ];

  if (finalStates.includes(status)) {
    return { showDeliveredDate: true, canCancel: false, showEstimate: false };
  }

  if (rtoStates.includes(status)) {
    return {
      showDeliveredDate: true,
      canCancel: false,
      showEstimate: false,
      isReturn: true,
    };
  }

  if (activeStates.includes(status)) {
    const canCancel = cancellableStates.includes(status.toLowerCase());
    return { showDeliveredDate: false, canCancel, showEstimate: true };
  }

  return {
    showDeliveredDate: false,
    canCancel: false,
    showEstimate: false,
    unknown: true,
  };
}

export function getDeliveryDate(cust_delivery_date, revised_delivery_date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // remove time part

  const customerDate = new Date(cust_delivery_date);
  if (customerDate < today && revised_delivery_date) {
    return revised_delivery_date; // if past, show revised
  } else {
    return moment(cust_delivery_date).format("YYYY-MM-DD"); // else show original
  }
}
